import { ThreeDPropertiesProvider } from "../../contexts/ThreeDPropertiesContext";
import PDPScreen from "./PDPScreen";
import { Props } from "./types";

const PDPWrapper = ({ route }: Props) => {
  return (
    <ThreeDPropertiesProvider>
      <PDPScreen key={route?.params?.productID} route={route} />
    </ThreeDPropertiesProvider>
  );
};

export default PDPWrapper;
